<div class="page-content">
  <app-equipamentos-nav [currentType]="'viaturas'" [currentTotal]="navTotal" />

  <div class="equipment-view-tabs" role="tablist" aria-label="Vista de viaturas">
    <button type="button" class="equipment-view-tab" [class.active]="activeSection === 'list'"
      (click)="activeSection = 'list'">
      <i class="ri-car-line"></i> Frota
    </button>
    <button type="button" class="equipment-view-tab" [class.active]="activeSection === 'maintenance'"
      (click)="activeSection = 'maintenance'">
      <i class="ri-tools-line"></i> Manutenção
      <span class="equipment-view-count" *ngIf="maintenanceCount > 0">{{ maintenanceCount }}</span>
    </button>
    <button type="button" class="equipment-view-tab" [class.active]="activeSection === 'configuration'"
      (click)="activeSection = 'configuration'">
      <i class="ri-settings-3-line"></i> Configura&ccedil;&atilde;o
    </button>
  </div>

  <div class="equip-tab active">
    <div class="inner-panel active" *ngIf="activeSection === 'list'">
      <!-- KPIs -->
      <app-equipamento-kpi-grid [items]="kpiItems" [columns]="5" />

      <p-menu #rowMenu [model]="menuItems" [popup]="true" appendTo="body"></p-menu>

      <!-- ACTION BAR -->
      <div class="table-actions-row" style="justify-content: flex-end;">
        <button type="button" class="btn-web-primary" (click)="openCreateDrawer()">
          <i class="fas fa-plus"></i> Registar Viatura
        </button>
      </div>

      <!-- TABLE -->
      <div class="data-table-wrapper">
        <div *ngIf="loading" class="skeleton-rows">
          <p-skeleton height="48px" *ngFor="let i of [1, 2, 3, 4, 5, 6]" styleClass="mb-2"></p-skeleton>
        </div>

        <div *ngIf="!loading">
          <app-empty-state *ngIf="filteredEquipamentos.length === 0" icon="pi pi-car" title="Nenhuma viatura encontrada"
            [message]="
              searchTerm
                ? 'Sem resultados para a pesquisa actual.'
                : 'Registe a primeira viatura.'
            " actionLabel="Registar Viatura" (action)="openCreateDrawer()">
          </app-empty-state>

          <table class="data-table viaturas-table" *ngIf="filteredEquipamentos.length > 0">
            <thead>
              <tr>
                <th class="col-matricula-head">Matrícula</th>
                <th>Marca/Modelo/Ano</th>
                <!--<th>Posto</th>-->
                <th>Motorista</th>
                <th>Estado</th>
                <th>Km Atual</th>
                <th>Seguro Até</th>
                <th>Próx. Revisão</th>
                <th class="text-right">Acções</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let e of filteredEquipamentos" class="clickable-row" (click)="verDetalhe(e)">
                <!-- 1. Matrícula -->
                <td class="col-matricula">
                  <div class="matricula-wrapper">
                    <div class="equip-thumb equip-thumb--sm" [ngClass]="getViaturaEstadoClass(e) || 'badge-default'">
                      <app-equipment-photo
                        [src]="e.fotoUrl"
                        [alt]="'Fotografia da viatura'"
                        [fallbackIcon]="'pi pi-car'"
                      />
                    </div>
                    <div class="matricula-text-box">
                      <span class="matricula-badge">{{ getMatricula(e) }}</span>
                      <span class="matricula-subcode" *ngIf="e.codigoInterno && e.codigoInterno !== getMatricula(e)">
                        {{ e.codigoInterno }}
                      </span>
                    </div>
                  </div>
                </td>

                <!-- 2. Marca/Modelo/Ano -->
                <td class="col-marca-modelo-ano">
                  <div class="marca-modelo-box">
                    <span class="marca-modelo-title">{{ getMarcaModelo(e) }}</span>
                    <span class="ano-sub" *ngIf="getAno(e)">· {{ getAno(e) }}</span>
                  </div>
                </td>

                <!-- 3. Posto -->
                <!--<td class="col-posto">
                  <div class="posto-box" *ngIf="getPostoAtribuido(e) !== '—'; else semPosto">
                    <i class="ri-building-2-line"></i>
                    <span>{{ getPostoAtribuido(e) }}</span>
                  </div>
                  <ng-template #semPosto>
                    <span class="text-muted-dash">—</span>
                  </ng-template>
                </td>>-->

                <!-- 4. Motorista -->
                <td class="col-motorista">
                  <div class="motorista-box" *ngIf="getMotorista(e) !== '—'; else semMotorista">
                    <i class="ri-user-line"></i>
                    <span>{{ getMotorista(e) }}</span>
                  </div>
                  <ng-template #semMotorista>
                    <span class="text-muted-dash">—</span>
                  </ng-template>
                </td>

                <!-- 5. Estado -->
                <td class="col-estado">
                  <span class="badge" [ngClass]="getViaturaEstadoClass(e)">
                    {{ getViaturaEstado(e) }}
                  </span>
                </td>

                <!-- 6. Km Atual -->
                <td class="col-km">
                  <span class="km-value" [class.text-muted-dash]="getKmAtual(e) === '—'">
                    {{ getKmAtual(e) }}
                  </span>
                </td>

                <!-- 7. Seguro Até -->
                <td class="col-seguro">
                  <span [class.text-danger]="isSeguroExpirado(e)" [class.text-muted-dash]="getSeguroAte(e) === '—'">
                    {{ getSeguroAte(e) }}
                  </span>
                </td>

                <!-- 8. Próx. Revisão -->
                <td class="col-revisao">
                  <span [class.text-muted-dash]="getProximaRevisao(e) === '—'">
                    {{ getProximaRevisao(e) }}
                  </span>
                </td>

                <!-- 9. Acções -->
                <td class="actions" (click)="$event.stopPropagation()">
                  <button class="btn-dots" type="button" (click)="openRowMenu($event, e)" title="Opções da Viatura">
                    <i class="pi pi-ellipsis-v"></i>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>

          <div class="equipment-pagination" *ngIf="totalRecords > 0">
            <app-paginator-control
              [first]="pageFirst"
              [rows]="pageSize"
              [totalRecords]="totalRecords"
              [rowsPerPageOptions]="[10, 20, 50]"
              (pageChange)="onPageChange($event)"
            />
          </div>
        </div>
      </div>
    </div>
    
    <div class="inner-panel active pt-3" *ngIf="activeSection === 'maintenance'">
      <app-frota-manutencao-tab [equipamentos]="equipamentos" (countChange)="onMaintenanceCountChange($event)"></app-frota-manutencao-tab>
    </div>

    <div class="inner-panel active configuration-panel-host" *ngIf="activeSection === 'configuration'">
      <app-tipos-equipamento [embedded]="true" [presetTipoId]="2" />
    </div>
  </div>

  <p-drawer
    [(visible)]="showCreateDrawer"
    position="right"
    [modal]="true"
    [blockScroll]="true"
    header="Registar Nova Viatura"
    styleClass="equip-create-drawer"
  >
    <app-novo-equipamento
      *ngIf="showCreateDrawer"
      [drawerMode]="true"
      [presetTipoId]="2"
      [IdCategoriaEquipamento]="IdCategoriaEquipamento"
      (closed)="showCreateDrawer = false"
      (saved)="onEquipmentSaved()"
    />
  </p-drawer>
</div>
